<div class="confirm-dialog-body">
  <div class="content-container">
    <span class="content-span">{{data.message}}</span>
  </div>

  <div class="actions-container">
    <button class="dialog-btn dialog-btn-cancel" [mat-dialog-close]="false">No</button>
    <button class="dialog-btn dialog-btn-confirm" [mat-dialog-close]="true">Yes</button>
  </div>
</div>
